import React, { useEffect } from "react";
import {
  Fab,
  Divider,
  Dialog,
  useMediaQuery,
  makeStyles,
} from "@material-ui/core";
import { BsFilter } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { addScenarioTotalsAsyncAction } from "app/scenarios/duck/actions";
import addCycleListAsyncAction from "app/common/cycle/duck/actions";
import { addCycleTypeList } from "app/common/cycle/duck/slices";
import { getCyclestype } from "lib/requests/cycles";
import PersistentDrawerLeft from "app/persistent-drawer-left/PersistentDrawerLeft";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Chart from "chart.js";
// import PrivateRoute from "app/auth/PrivateRoute";
import { setActionList } from "app/recommendation-engine/duck/slices";
import EstimationsParentComponent from "app/estimations/EstimationsParentComponent";
import ScenarioSidebarComponent from "app/scenarios/ScenarioSidebarComponent";
import FiltersComponent from "app/filters/FiltersComponent";
import HistoryComponent from "app/history/HistoryComponent";
import useDidMountEffect, { useEffectAsync } from "lib/react/customHooks";
import ElasticityComponent from "app/elasticity/ElasticityComponent";
import CompetitorsComponent from "app/competitors/CompetitorsComponent";
import CompetitorsOldComponent from "app/competitorsOld/CompetitorsOldComponent";
import { recommendationGetActions } from "lib/requests/recommendationEngine";
import ConsentDialogComponent from "app/auth/utils/ConsentDialogComponent";
import Cookies from "universal-cookie";
import DemandPlanningComponent from "app/demand/DemandPlanningComponent";
import MaintenanceDialog from "app/common/dialog/MaintenanceDialog";
import ChatBotComponent from "app/chatbot/ChatBotComponent";
// import NewFeatDialogComponent from "app/auth/NewFeatDialogComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("xs")]: {
      marginLeft: "0",
      padding: "10px",
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: "0",
      padding: "10px",
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: "0",
      padding: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      marginLeft: "90px",
      padding: "0px",
    },
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: "3",
  },
  contentContainer: {
    backgroundColor: "#ffffff",
    [theme.breakpoints.up("xs")]: {
      padding: "15px 0px 15px 0px",
    },
    [theme.breakpoints.up("lg")]: {
      padding: "15px",
    },

    borderRadius: "5px",
    /* height: 88%, */
    border: "1px solid #e2e2e2",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
  },
}));

// We want to increase the hit radius on points so that the tooltip is easier to trigger
Chart.defaults.global.elements.point.hitRadius = 15;

// This code snippet allows rendering text inside the doughnut
const originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;

Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
  draw() {
    originalDoughnutDraw.apply(this);

    const { chart } = this;
    const { width } = chart.chart;
    const { height } = chart.chart;
    const { ctx } = chart.chart;

    const fontSize = (height / 114).toFixed(2);
    ctx.font = `${fontSize}em Lato`;
    ctx.fillStyle = "#545455";
    ctx.textBaseline = "middle";

    const { text } = chart.config.data;
    const textX = Math.round((width - ctx.measureText(text).width) / 2);
    const textY = height / 2 + chart.titleBlock.height / 2;
    ctx.fillText(text, textX, textY);
    ctx.save();
  },
});

const cookies = new Cookies();

function HomeComponent() {
  const classes = useStyles();
  const cycleSlice = useSelector((state) => state.cycle);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const { path } = useRouteMatch();
  const [openMaintenance, setOpenMaintenance] = React.useState(false);
  const configCatSlice = useSelector((state) => state.auth.configCatUser);
  const user = useSelector((state) => state.auth.user);
  const loginUserConsent = cookies.get("loginUserConsent")?.[user.username];
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(
    !loginUserConsent
  );
  const IsOldCompetitors = configCatSlice?.features.IsOldCompetitors;

  const handleDialogClose = () => {
    cookies.set(
      "loginUserConsent",
      JSON.stringify({
        ...cookies.get("loginUserConsent"),
        [user.username]: true,
      }),
      { path: "/" }
    );
    setConfirmDialogOpen(false);
  };

  useEffectAsync(
    async () => {
      return recommendationGetActions();
    },
    (result) => {
      dispatch(setActionList(result.data));
    },
    []
  );

  useEffectAsync(
    async () => {
      return getCyclestype().then((response) => {
        return response;
      });
    },
    (result) => {
      dispatch(addCycleTypeList(result));
    },
    []
  );

  useEffect(() => {
    dispatch(addCycleListAsyncAction());
  }, []);

  useDidMountEffect(() => {
    dispatch(
      addScenarioTotalsAsyncAction({
        filters: {
          scenario_type_id: [1, 3],
        },
        expand: ["scenario", "scenario.cycle"],
      })
    );
  }, [cycleSlice.list]);

  useEffect(() => {
    setOpenMaintenance(configCatSlice?.features?.IsMaintenanceActive);
  }, [configCatSlice?.features?.IsMaintenanceActive]);

  const handleOnClose = () => {
    setOpen(false);
  };

  // Uncomment the following lines if you want to use the NewFeatDialogComponent
  // const [showNewFeatDialog, setShowNewFeatDialog] = React.useState(false);
  // useEffect(() => {
  //   if (!confirmDialogOpen) setShowNewFeatDialog(true);
  //   else setShowNewFeatDialog(false);
  // }, [confirmDialogOpen]);

  return (
    <div className={classes.root}>
      <ConsentDialogComponent
        open={confirmDialogOpen}
        handleClose={handleDialogClose}
        isSmallScreen
      />
      {/* <NewFeatDialogComponent
        featName="announcementSummaryPromotions"
        header="Value Destroyers Available"
        body={`You can now identify which promotions generate or destroy value for your scenarios. Clic below and select the new "Promotions" tab!`}
        pathToGo={`${window.location.pathname}/`}
        onClick={() => {}}
        show={showNewFeatDialog}
        configCatFeatName=""
        isSmallScreen={isSmallScreen}
      /> */}
      {isSmallScreen ? (
        <div className={classes.contentContainer}>
          <Fab
            color="primary"
            aria-label="add"
            onClick={() => setOpen(true)}
            className={classes.fab}
          >
            <BsFilter size={30} />
          </Fab>
          <Dialog open={open} onClose={handleOnClose}>
            <>
              <ScenarioSidebarComponent />
              <Divider />
              <FiltersComponent />
            </>
          </Dialog>

          <div className={classes.mainContent}>
            <Switch>
              <Route
                exact
                path={`${path}`}
                component={EstimationsParentComponent}
              />
              <Route
                exact
                path={`${path}/pricing`}
                component={EstimationsParentComponent}
              />
              <Route
                exact
                path={`${path}/history`}
                component={HistoryComponent}
              />
              <Route
                exact
                path={`${path}/elasticity`}
                component={ElasticityComponent}
              />
              {IsOldCompetitors ? (
                <Route
                  exact
                  path={`${path}/competitors`}
                  component={CompetitorsOldComponent}
                />
              ) : (
                <Route
                  exact
                  path={`${path}/competitors`}
                  component={CompetitorsComponent}
                />
              )}
              <Route
                exact
                path={`${path}/demand`}
                component={DemandPlanningComponent}
              />
            </Switch>
          </div>
        </div>
      ) : (
        <PersistentDrawerLeft
        // confirmDialogOpen={confirmDialogOpen}
        // handleDialogClose={handleDialogClose}
        />
      )}
      <MaintenanceDialog
        title="Wise Athena is working on predicting multiple futures"
        content={
          <div>
            Your console is getting Wise Athena most updated AI models, Please
            check back soon. <br />
            Feel free to go for a coffee while you wait, have you tried yoga?
          </div>
        }
        open={openMaintenance}
      />
      <ChatBotComponent />
    </div>
  );
}

export default HomeComponent;
